const $ = jQuery;
$.getJSON('/flash-message.json').then(data => {
  if (data.flash.notice) {
    const $bar = $('<div class="bg-white border-bottom border-base-color"><div class="container-fluid message-bar "><p></p></div></div>');
    $bar.find('p').text(data.flash.notice);
    $bar.insertBefore('main');
  }
})
